/* istanbul ignore file */
import { SidebarStickyMenu, SummaryMenuItem, ActivitiesMenuItem } from 'framework/ui/menu';
import { useParams } from 'react-router-dom';
import { ContactsMenuItem } from 'domain/sales/contact';
import { OpportunitiesMenuItem } from 'domain/sales/opportunity';
import { useAuthorization } from 'framework/authorization';
import { READ_RELATED_CONTACTS, READ_RELATED_OPPORTUNITIES, READ_TIMELINE } from 'domain/sales/salesService';
import ClientPortalMenuItem from '../clientPortal/ClientPortalMenuItem';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import useAccountUrl from '../useAccountUrl';
import { DELIVERY_ACCOUNT_READ_CLIENT_PORTAL_USERS } from '../model';

const ShowAccountPageMenu = () => {
  const { id = '' } = useParams<Dictionary<string>>();
  const {
    getSingleEntityUrl,
    getTimelineUrl,
    getRelatedOpportunitiesUrl,
    getRelatedContactsUrl,
    getAccountClientPortalUrl,
  } = useAccountUrl();
  const { isGranted } = useAuthorization();
  const { isFeatureEnabled } = useFeatureToggle();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl(id)} exact />
      <ActivitiesMenuItem linkUrl={getTimelineUrl(id)} isVisible={isGranted(READ_TIMELINE)} />
      <OpportunitiesMenuItem
        linkUrl={getRelatedOpportunitiesUrl(id)}
        isVisible={isGranted(READ_RELATED_OPPORTUNITIES)}
      />
      <ContactsMenuItem
        name="Contacts"
        linkUrl={getRelatedContactsUrl(id)}
        isVisible={isGranted(READ_RELATED_CONTACTS)}
      />
      {
        <ClientPortalMenuItem
          name="Client portal"
          linkUrl={getAccountClientPortalUrl(id)}
          isVisible={isFeatureEnabled(Features.CLIENT_PORTAL) && isGranted(DELIVERY_ACCOUNT_READ_CLIENT_PORTAL_USERS)}
        />
      }
    </SidebarStickyMenu>
  );
};

export default ShowAccountPageMenu;
